import { http } from "@/http/http.js";
export default {
  //查询工作项基础库信息
  queryAllWorkInfo(params) {
    return http.post("/web/workitem/queryAllWorkInfo", params);
  },
  //根据工作项基础Id查询工作项清单
  queryItemByWorkId(params) {
    return http.post("/web/workitem/queryItemByWorkId", params);
  },
  //新增工作项
  saveNewWorkinfo(params) {
    return http.post("/web/workitem/save", params);
  },
  //修改工作项清单
  updateWorkinfo(params) {
    return http.post("/web/workitem/update", params);
  },
  //删除工作项
  deleteWorkinfo(params) {
    return http.post("/web/workitem/delete", params);
  },
};
